import { Logger } from '../logging/default-log.service';

/**
 * Service that holds methods to check browsers and their respective features
 *
 * @author Patrick van Zadel
 */
export class BrowserService {
  logger: Logger;

  constructor(logger: Logger) {
    this.logger = logger;
  }

  /**
   * Only targets Microsft Edge Legacy browsers. This will not return true if it's
   * the chrome based Edge Browser.
   *
   * Microsoft have announced they will stop supporting Microsoft Edge Legacy on
   * March 9th 2021.
   *
   * {@link https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666}
   *
   * @return true if the user is using Microsoft Edge Legacy
   */
  public static isEdgeBrowser(): boolean {
    return /Edge\//.test(navigator.userAgent);
  }
}
